import { Controller } from "@hotwired/stimulus"

export default class NavbarActiveController extends Controller<HTMLElement> {
  static targets = ["link"]

  declare readonly linkTargets: HTMLElement[]

  connect(): void {
    this.update()
    document.addEventListener("turbo:load", this.update)
  }

  disconnect(): void {
    document.removeEventListener("turbo:load", this.update)
  }

  activate(event: Event): void {
    const clickedLink = event.currentTarget as HTMLElement
    const path = clickedLink.dataset.navbarActivePathValue
    if (!path) return

    this.applyActiveState(path)
  }

  update = (): void => {
    this.applyActiveState(window.location.pathname)
  }

  private applyActiveState(currentPath: string): void {
    this.linkTargets.forEach((link) => {
      const path = link.dataset.navbarActivePathValue
      if (!path) return

      const activeClasses = (link.dataset.navbarActiveActiveClassValue || "").split(" ").filter(Boolean)
      const inactiveClasses = (link.dataset.navbarActiveInactiveClassValue || "").split(" ").filter(Boolean)

      const isActive = currentPath === path || currentPath.startsWith(path + "/")

      link.classList.remove(...activeClasses, ...inactiveClasses)
      link.classList.add(...(isActive ? activeClasses : inactiveClasses))
    })
  }
}
